export default __webpack_public_path__ + "static/media/milestone 950.8a99500b.svg";